import { useNavigate } from 'react-router-dom';
import { Crown, Sparkles, Users, Radio, ArrowRight, X } from 'lucide-react';

const UNLOCKED = [
  { icon: Sparkles, text: 'The Co\u2011Creation Chamber and collective intention boards' },
  { icon: Users, text: 'Intention pods, circles, and Community Engagement' },
  { icon: Radio, text: 'Live activations and the Archive of Collective Work' },
];

/**
 * One-time card shown the moment a member gains Platinum+ entry.
 * Dismissing it (either button) marks it seen for good.
 */
export const PlatinumEntryCard = ({ onDismiss }) => {
  const navigate = useNavigate();

  const enter = () => {
    onDismiss();
    navigate('/dashboard/platinum-plus');
  };

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-950/80 backdrop-blur-sm"
      data-testid="platinum-entry-card-overlay"
    >
      <div
        className="relative w-full max-w-lg rounded-2xl border border-amber-400/30 bg-gradient-to-b from-slate-900 to-slate-950 p-8 shadow-[0_0_60px_rgba(251,191,36,0.15)]"
        data-testid="platinum-entry-card"
      >
        <button
          onClick={onDismiss}
          className="absolute right-4 top-4 text-slate-500 transition-colors hover:text-slate-200"
          aria-label="Close"
          data-testid="platinum-entry-close-btn"
        >
          <X className="h-5 w-5" />
        </button>

        <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-full border border-amber-400/40 bg-amber-400/10">
          <Crown className="h-7 w-7 text-amber-300" />
        </div>

        <p className="mb-2 text-xs uppercase tracking-[0.2em] text-amber-300/80">Entry granted</p>
        <h2 className="mb-3 text-2xl font-bold text-white">You&rsquo;ve entered Platinum+</h2>
        <p className="mb-6 text-sm leading-relaxed text-slate-300">
          Platinum+ is the graduated space beyond the coaching program &mdash; where members who have
          completed the work gather to set intention together. Your access is now permanent, and
          Platinum+ lives in your sidebar from here on.
        </p>

        <ul className="mb-8 space-y-3">
          {UNLOCKED.map(({ icon: Icon, text }) => (
            <li key={text} className="flex items-start gap-3 text-sm text-slate-300">
              <Icon className="mt-0.5 h-4 w-4 flex-shrink-0 text-amber-300/70" />
              <span>{text}</span>
            </li>
          ))}
        </ul>

        <div className="flex flex-col gap-3 sm:flex-row">
          <button
            onClick={enter}
            className="inline-flex flex-1 items-center justify-center gap-2 rounded-full bg-amber-400 px-6 py-3 text-sm font-semibold text-slate-950 transition-colors hover:bg-amber-300"
            data-testid="platinum-entry-enter-btn"
          >
            Enter Platinum+ <ArrowRight className="h-4 w-4" />
          </button>
          <button
            onClick={onDismiss}
            className="rounded-full border border-slate-700 px-6 py-3 text-sm font-medium text-slate-300 transition-colors hover:border-slate-500 hover:text-white"
            data-testid="platinum-entry-later-btn"
          >
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlatinumEntryCard;
